import { useEffect, useRef, useState } from 'react';

import { useProjectSiteSwitch } from './use-project-site-switch';

export const useProjectSiteSelector = () => {
  const [open, setOpen] = useState(false);
  const listRef = useRef<HTMLDivElement>(null);
  const { projects, projectId, siteId, switchSite } = useProjectSiteSwitch();

  useEffect(() => {
    if (!open) return;

    const frame = requestAnimationFrame(() => {
      const list = listRef.current;
      const item = list?.querySelector<HTMLElement>('[cmdk-item][aria-selected="true"]');
      if (!list || !item) return;

      const heading = item.closest('[cmdk-group]')?.querySelector<HTMLElement>('[cmdk-group-heading]');
      list.scrollTop = item.offsetTop - list.offsetTop - (heading?.offsetHeight ?? 0);
    });

    return () => cancelAnimationFrame(frame);
  }, [open]);

  const selectSite = (nextProjectId: number, nextSiteId: number) => {
    switchSite(nextProjectId, nextSiteId);
    setOpen(false);
  };

  const selectFirstSite = (heading: HTMLElement, nextProjectId: number) => {
    const firstSiteId = heading.closest('[cmdk-group]')?.querySelector<HTMLElement>('[cmdk-item]')?.dataset.siteId;
    if (!firstSiteId) return;

    selectSite(nextProjectId, Number(firstSiteId));
  };

  const selectedProject = projects?.find((p) => p.id === projectId);
  const selectedSite = selectedProject?.sites.find((s) => s.id === siteId);
  const selectedValue = selectedProject && selectedSite ? `${selectedProject.name} ${selectedSite.name}` : undefined;

  return { open, setOpen, listRef, projects, projectId, siteId, selectedValue, selectSite, selectFirstSite };
};
